import React from "react";
import { Link } from "react-router-dom";

// This is the component for a single article detail page
const FirstBlog = () => {
  // This would typically be fetched based on URL params in a real app
  // Using the data from the first card as an example
  const article = {
    id: 1,
    title:
      "Still Muslim-owned. This is what it looks like when you don't fold...",
    subtitle: "10 Years In, Here's What Happened",
    category: "SELECT",
    publishDate: "April 20, 2025",
    author: {
      name: "Ahmed Khan",
      title: "Founder, Muzz",
      image: "https://randomuser.me/api/portraits/men/32.jpg",
    },
    featuredImage:
      "https://images.unsplash.com/photo-1527842891421-42eec6e703ea?fm=jpg&q=60&w=3000&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MjB8fG5pZ2h0JTIwc2t5JTIwbW9vbnxlbnwwfHwwfHx8MA%3D%3D",
    readTime: "6 min read",
    content: `
      <h2 style="font-family: Georgia, serif; font-weight: 800; color: #730000; font-size: 1rem;">A Decade of Persistence</h2>
      <p>Three lawsuits. One name lost. Ten million members later, we're still here. Three acquisition offers. Three lawsuits. A name we built from scratch — taken. But we're still standing, still Muslim-owned, and stronger than ever before.</p>
      
      <p>When we launched Muzz (formerly known as Muzmatch) back in 2015, we had a simple mission: to create a space where Muslims could meet each other for marriage in a way that respected our traditions and values. Little did we know that this journey would take us through courtrooms, boardrooms, and ultimately to becoming one of the most successful Muslim-owned tech companies in the world.</p>
      
      <h2 style="font-family: Georgia, serif; font-weight: 800; color: #730000; font-size: 1rem;">The Legal Battles</h2>
      <p>Our first major challenge came in the form of a trademark dispute. A large dating conglomerate claimed our name was too similar to theirs, despite the clear differences in our communities and approach. The legal battle drained our resources and tested our resolve.</p>
      
      <p>"There were moments when it would have been easier to just give in," recalls our founder. "Big companies with deep pockets can make life very difficult for startups like ours. But we knew what we were building was important for our community."</p>
      
      <p>After an exhausting legal process, we made the difficult decision to rebrand from Muzmatch to Muzz. It was a painful transition, but one that ultimately strengthened our identity and clarified our mission.</p>
      
      <h2 style="font-family: Georgia, serif; font-weight: 800; color: #730000; font-size: 1rem;">The Acquisition Offers</h2>
      <p>As our user base grew to millions across the globe, the acquisition offers started coming in. First from smaller companies, then from major dating conglomerates, and finally from investment groups with eye-watering valuations.</p>
      
      <p>The offers were tempting. The numbers being discussed would have meant financial security not just for our founders, but for generations to come. But there was always a catch: loss of control over the direction of the platform, integration with non-halal services, or compromises on our core values.</p>
      
      <p>"We didn't build Muzz just to sell it to the highest bidder," our CEO explains. "We built it because our community needed it. Selling would have meant betraying that trust."</p>
      
      <h2 style="font-family: Georgia, serif; font-weight: 800; color: #730000; font-size: 1rem;">Staying True to Our Roots</h2>
      <p>Despite the challenges, Muzz has remained committed to its founding principles:</p>
      
      <ul>
        <li>Providing a safe, halal environment for Muslims to find spouses</li>
        <li>Respecting Islamic values in all aspects of the platform</li>
        <li>Maintaining Muslim ownership and control</li>
        <li>Building technology that serves our community's unique needs</li>
        <li>Creating a sustainable business that can continue to serve future generations</li>
      </ul>
      
      <p>This commitment hasn't always been easy. There have been times when taking investment from certain sources would have accelerated our growth, or when making compromises on our values would have opened new markets.</p>
      
      <h2 style="font-family: Georgia, serif; font-weight: 800; color: #730000; font-size: 1rem;">The Impact</h2>
      <p>Ten years and ten million users later, the impact of staying true to our mission is clear. Muzz has been responsible for hundreds of thousands of marriages across the globe. We've connected Muslims from different cultures, backgrounds, and countries who might never have met otherwise.</p>
      
      <p>Beyond the marriages, we've created a technology company that proves Muslim entrepreneurs can succeed without compromising their values. We've built a team that reflects the diversity of the global Muslim community, with employees from dozens of countries and backgrounds.</p>
      
      <h2 style="font-family: Georgia, serif; font-weight: 800; color: #730000; font-size: 1rem;">Looking Ahead</h2>
      <p>As we look to the next decade, our vision remains clear: to continue building technology that serves the Muslim community with integrity and excellence. We're exploring new features, new markets, and new ways to support Muslims in their journey to find a spouse.</p>
      
      <p>We're also investing in the next generation of Muslim entrepreneurs through mentorship programs and a newly established venture fund. Our hope is that our story inspires others to build businesses that serve our community while staying true to their values.</p>
      
      <p>The journey hasn't been easy, and we don't expect the path forward to be without challenges. But if the last decade has taught us anything, it's that staying true to your principles, even when it's difficult, is always the right choice in the long run.</p>
      
      <p>Still Muslim-owned. Still committed to our community. Still here.</p>
    `,
    tags: [
      "Muslim Tech",
      "Startup Journey",
      "Muslim Entrepreneurs",
      "Marriage Apps",
      "Muslim Business",
    ],
    relatedPosts: [
      {
        id: 2,
        title:
          "Did Mohamed Ever Find a Wife? The Inside Scoop of SelectProposal Most Viral Campaign",
        image:
          "https://plus.unsplash.com/premium_photo-1677966145676-8641eb66b942?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
        category: "SELECT",
      },
      {
        id: 3,
        title: "When is Laylatul Qadr in 2025?",
        image:
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRJs1bb8HttfWaE9yXn58_2aamN40gt4PRj5g&s",
        category: "COMMUNITY",
      },
      {
        id: 4,
        title: "3,000 Muslims Took Over Times Square for Taraweeh",
        image: "https://i.ytimg.com/vi/ePQ9_re7f1A/maxresdefault.jpg",
        category: "COMMUNITY",
      },
    ],
  };

  return (
    <div className="font-sans max-w-4xl mx-auto p-4 pb-16">
      {/* Breadcrumb Navigation */}
      <div className="flex items-center text-sm text-gray-500 mb-6">
        <Link to="/" className="hover:text-pink-500">
          Home
        </Link>
        <span className="mx-2">/</span>
        <Link to="/blogs" className="hover:text-pink-500">
          Blogs
        </Link>
        <span className="mx-2">/</span>
        <span className="text-gray-700">
          {article.title.substring(0, 30)}...
        </span>
      </div>

      {/* Category Tag */}
      <div className="mb-4 text-pink-500 font-bold">{article.category}</div>

      {/* Article Title */}
      <h1 className="text-4xl font-serif font-bold mb-2">{article.title}</h1>
      <h2 className="text-2xl font-serif text-gray-600 mb-6">
        {article.subtitle}
      </h2>

      {/* Article Meta */}
      <div className="flex items-center justify-between mb-8 border-b border-gray-200 pb-4">
        <div className="flex items-center">
          <img
            src={article.author.image}
            alt={article.author.name}
            className="w-12 h-12 rounded-full mr-4 hover:scale-105 transition-transform duration-300"
          />
          <div>
            <div className="font-medium">{article.author.name}</div>
            {/* <div className="text-sm text-gray-500">{article.author.title}</div> */}
          </div>
        </div>
        <div className="text-sm text-gray-500">
          <span>{article.publishDate}</span>
          <span className="mx-2">•</span>
          <span>{article.readTime}</span>
        </div>
      </div>

      {/* Featured Image with Label */}
      <div className="mb-8 relative">
        <img
          src={article.featuredImage}
          alt={article.title}
          className="w-full h-auto rounded-lg shadow-md hover:scale-105 transition-transform duration-300"
        />
        <div className="absolute top-4 right-4 bg-pink-500 text-white p-3 text-sm font-bold">
          <div>Made by Muslims</div>
          <div>For Muslims</div>
        </div>
      </div>

      {/* Article Content */}
      <div
        className="prose prose-lg max-w-none mb-12"
        dangerouslySetInnerHTML={{ __html: article.content }}
      />

      {/* Tags */}
      <div className="mb-12">
        <h3 className="text-lg font-serif font-bold mb-4 text-pink-500">
          Related Topics
        </h3>
        <div className="flex flex-wrap gap-2">
          {article.tags.map((tag, index) => (
            <span
              key={index}
              // to={`/tags/${tag.toLowerCase().replace(/\s+/g, "-")}`}
              className="bg-gray-100 cursor-default hover:bg-gray-200 text-gray-800 px-3 py-1 rounded-full text-sm"
            >
              {tag}
            </span>
          ))}
        </div>
      </div>

      {/* Author Box */}
      <div className="bg-gray-50 p-6 rounded-lg shadow-sm mb-12">
        <div className="flex items-start">
          <img
            src={article.author.image}
            alt={article.author.name}
            className="w-16 h-16 rounded-full mr-6 hover:scale-105 transition-transform duration-300"
          />
          <div>
            <h3 className="font-bold text-lg font-serif mb-2">
              About {article.author.name}
            </h3>
            <p className="text-gray-700 mb-4">
              Ahmed Khan is the founder of Muzz, previously known as Muzmatch.
              With a background in technology and a passion for serving the
              Muslim community, he has led the company through significant
              challenges to build one of the most successful Muslim marriage
              platforms worldwide.
            </p>
            <div className="flex gap-4">
              <Link
                // to="/blogs/select-proposal"
                className="text-pink-500 hover:text-pink-700"
              >
                More articles by this author
              </Link>
              <span
                // href="https://linkedin.com/in/ahmedkhan"
                className="text-pink-500 cursor-default hover:text-pink-700"
              >
                Follow on LinkedIn
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* Related Posts */}
      <div>
        <h3 className="text-2xl font-serif font-bold mb-6 cursor-default text-pink-500">
          Related Articles
        </h3>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 ">
          {article.relatedPosts.map((post) => (
            <span
              key={post.id}
              className="border-b-4 border-red-600 rounded-bl-md rounded-br-md"
            >
              <div className="mb-3">
                <img
                  src={post.image}
                  alt={post.title}
                  className="w-full h-48 object-cover rounded-lg hover:scale-105 transition-transform duration-300"
                />
              </div>
              <div className="mb-1 text-pink-500 font-bold text-sm cursor-default">
                {post.category}
              </div>
              <h4 className="text-lg font-serif font-bold hover:text-[#730000] cursor-default">
                {post.title}
              </h4>
            </span>
          ))}
        </div>
      </div>
    </div>
  );
};

// This is the component displaying the card grid that links to article details
const MuzzArticleCards = () => {
  const articles = [
    {
      id: 1,
      title:
        "Still Muslim-owned. This is what it looks like when you don't fold...",
      subtitle: "10 Years In, Here's What Happened",
      excerpt:
        "Three lawsuits. One name lost. Ten million members later, we're still here. Three acquisition offers. Three lawsuits.",
      image:
        "https://images.unsplash.com/photo-1527842891421-42eec6e703ea?fm=jpg&q=60&w=3000&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MjB8fG5pZ2h0JTIwc2t5JTIwbW9vbnxlbnwwfHwwfHx8MA%3D%3D",
      badge: {
        top: "Made by Muslims",
        bottom: "For Muslims",
      },
      bottomLabel: "10 Years In, Here's What Happened",
    },
    {
      id: 2,
      title:
        "Did Mohamed Ever Find a Wife? The Inside Scoop of SelectProposal's Most Viral Campaign",
      excerpt:
        '"Mohamed, that\'s you??" At this point, everyone has seen the huge pink billboards.',
      image:
        "https://plus.unsplash.com/premium_photo-1677966145676-8641eb66b942?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    },

    {
      id: 3,
      title: "When is Laylatul Qadr in 2025?",
      excerpt:
        "We're already halfway through Ramadan, and we're about to enter the most holiest night in Islam. The last ten nights of Ramadan are extra special, especially the odd ones, as this is when...",
      image:
        "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRJs1bb8HttfWaE9yXn58_2aamN40gt4PRj5g&s",
    },
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
      {articles.map((article) => (
        <Link
          key={article.id}
          to={`/articles/${article.id}`}
          className="relative block hover:opacity-95 transition-opacity"
        >
          <div className="relative">
            <img
              src={article.image}
              alt={article.title}
              className="w-full h-48 object-cover"
            />
            {article.badge && (
              <div className="absolute top-0 right-0 bg-pink-500 text-white p-2 text-sm">
                <div>{article.badge.top}</div>
                <div>{article.badge.bottom}</div>
              </div>
            )}
            {article.bottomLabel && (
              <div className="absolute bottom-8 left-0 bg-white bg-opacity-75 p-1">
                <p className="text-sm font-bold">{article.bottomLabel}</p>
              </div>
            )}
            <h3 className="font-serif font-bold mt-3">{article.title}</h3>
            <p className="text-xs mt-1">{article.excerpt}</p>
          </div>
        </Link>
      ))}
    </div>
  );
};

export { FirstBlog, MuzzArticleCards };
